module.exports = __webpack_public_path__ + "img/DE05701.6b802461.png";